import { render, staticRenderFns } from "./Unit5ENG.vue?vue&type=template&id=97f54b60&scoped=true&"
import script from "./Unit5ENG.vue?vue&type=script&lang=js&"
export * from "./Unit5ENG.vue?vue&type=script&lang=js&"
import style0 from "./Unit5ENG.vue?vue&type=style&index=0&id=97f54b60&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f54b60",
  null
  
)

export default component.exports